import React, { ComponentProps, ChangeEvent } from 'react'
import { useIsScrollingDown } from 'hooks/useIsScrollingDown'
import { Header } from 'components/Header'
import { AllProductsHeaderRoot } from './AllProductsHeader.styles'
import { ProductTypes } from 'models/Product'
import { Proteins } from 'models/Pet'

type AllProductsHeaderOwnProps = ComponentProps<typeof AllProductsHeaderRoot>
export type AllProductsHeaderProps = AllProductsHeaderOwnProps & {
  typesFilter: ProductTypes[]
  proteinsFilter: Proteins[]
  handleSearch: (e: ChangeEvent<HTMLInputElement>) => void
  onTypesChange: (e: ChangeEvent<HTMLInputElement>) => void
  onProteinsChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const AllProductsHeader = ({
  typesFilter,
  proteinsFilter,
  handleSearch,
  onTypesChange,
  onProteinsChange,
}: AllProductsHeaderProps) => {
  const isScrollingDown = useIsScrollingDown()

  return (
    <AllProductsHeaderRoot isScrollingDown={isScrollingDown}>
      <Header />
      {/* <MobileMenu
        isScrollingDown={isScrollingDown}
        onProteinsChange={onProteinsChange}
        onTypesChange={onTypesChange}
        handleSearch={handleSearch}
        typesFilter={typesFilter}
        proteinsFilter={proteinsFilter}
      /> */}
    </AllProductsHeaderRoot>
  )
}

AllProductsHeader.displayName = 'AllProductsHeader'
